import React from "react";
import { useQuery, gql } from "@apollo/client";

// Every status change on one leave request, newest first.

const GET_LEAVE_HISTORY = gql`
  query GetLeaveRequestHistory($leaveRequestId: ID!) {
    getLeaveRequestHistory(leaveRequestId: $leaveRequestId) {
      id
      oldStatus
      newStatus
      remark
      changedAt
      admin {
        id
        fullName
      }
    }
  }
`;

const LeaveHistoryModal = ({ leave, onClose }) => {
  const { data, loading, error } = useQuery(GET_LEAVE_HISTORY, {
    variables: { leaveRequestId: leave.id },
    fetchPolicy: "network-only",
  });
  const rows = data?.getLeaveRequestHistory || [];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg p-6 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            History · {leave.employee?.fullName}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl leading-none"
          >
            ×
          </button>
        </div>
        {loading && <p className="text-sm text-gray-500">Loading...</p>}
        {error && (
          <p className="text-sm text-red-600">Could not load history.</p>
        )}
        {!loading && !error && rows.length === 0 && (
          <p className="text-sm text-gray-500">No history recorded.</p>
        )}
        <ol className="relative border-l border-gray-200 ml-2">
          {rows.map((row) => (
            <li key={row.id} className="mb-4 ml-4">
              <div className="absolute w-2.5 h-2.5 bg-gray-300 rounded-full -left-[5px] mt-1.5" />
              <p className="text-sm font-medium text-gray-800">
                {row.oldStatus ? `${row.oldStatus} → ` : ""}
                {row.newStatus}
              </p>
              <p className="text-xs text-gray-500">
                {new Date(row.changedAt).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                })}{" "}
                · {row.admin?.fullName || "Employee"}
              </p>
              {row.remark && (
                <p className="text-sm text-gray-600 mt-1">{row.remark}</p>
              )}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default LeaveHistoryModal;
